import { createApplicationState } from '../applicationState';
import { renderApplication } from '../renderApplication';
import { createContext } from './createContext';
import { loadCareerPage } from 'career-entry';
import { EPageType } from '../../../shared/types/page';

export function runApp() {
  const context = createContext();

  const store = createApplicationState(context);

  const pageType = store.getState?.()?.page?.type;
  if (
    [
      EPageType.Career,
      EPageType.CareerVacancies,
      EPageType.CareerVacancy,
      EPageType.CareerTeamMarketing,
      EPageType.CareerTeamAnalytics,
      EPageType.CareerTeamTechnologies,
      EPageType.CareerTeamProduct,
      EPageType.CareerTeamBackoffice,
    ].includes(pageType)
  ) {
    void loadCareerPage(pageType).then(() => renderApplication({ context, store }));

    return;
  }

  renderApplication({ context, store });
}
